(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/common/visit-game-button.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/common/visit-game-button.js');

'use strict';

const {
  Link
} = ReactRouterDOM;
const Button = svs.ui.ReactButton;
const {
  useWagers
} = svs.components.marketplaceCompetition.services.hooks;
const {
  getOngoingBetPath
} = svs.components.marketplaceCompetition.overviewHero.helpers;
const {
  REG_CLOSED_DRAW_FINALIZED
} = svs.components.marketplaceCompetition.competitionHandler.common.constants.competitionStates;
const VisitGameButton = _ref => {
  var _wagers$currentDrawNu;
  let {
    competition,
    label
  } = _ref;
  const wagers = useWagers(competition.id);
  let currentDrawNumber = competition === null || competition === void 0 ? void 0 : competition.details.currentDrawNumber;
  if (competition.status === REG_CLOSED_DRAW_FINALIZED) {
    currentDrawNumber = currentDrawNumber - 1;
  }
  const wagerSerial = wagers === null || wagers === void 0 || (_wagers$currentDrawNu = wagers[currentDrawNumber]) === null || _wagers$currentDrawNu === void 0 ? void 0 : _wagers$currentDrawNu.wagerSerial;
  return React.createElement("div", {
    className: "overview-hero-button-container"
  }, React.createElement(Link, {
    className: "qa-to-competition-live-bet",
    to: {
      pathname: getOngoingBetPath(competition, wagerSerial)
    }
  }, React.createElement(Button, {
    className: "button-250 qa-competition-overview-hero-open-game-button"
  }, label)));
};
VisitGameButton.defaultProps = {
  label: 'Till spelet'
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.common.VisitGameButton', VisitGameButton);

 })(window);